import backend from './backend';

const endpoint = '/shop';

export default {
    get(){
        return backend.get(endpoint).then(response => response.data)
    }
}